import UserApi from "@/api/User";
import ModelFactory from "@/model/ModelFactory";
import UserModel from "@/model/User";

import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
//name: "User"
@Module({ namespaced: true })
export default class UserModule extends VuexModule {
  public user: UserModel = ModelFactory.create("UserModel");
  public loading: boolean = false;

  @Mutation public setUser(user: UserModel) {
    this.user = ModelFactory.create("UserModel", user);
  }

  @Mutation public setPermissions(permissions: object) {
    this.user.permissions = permissions;
  }

  get userId(): number {
    return this.user.id;
  }

  get hasPermission(): Function {
    return function(permission: string): boolean {
      return this.user.hasPermission(permission);
    };
  }

  get getOrganization(): string {
    return this.user.organization;
  }

  get isAdmin(): boolean {
    return this.user.id > 0 && this.user.hasPermission("admin");
  }

  get isUser(): boolean {
    return this.user.id > 0 && !this.user.hasPermission("admin");
  }

  @Action({ rawError: true }) public getCurrent(reload: boolean = false) {
    if (this.user.id && !reload) {
      return new Promise(resolve => resolve(this.user));
    } else {
      return UserApi.getCurrent({ reload }).then((res: any) => {
        this.context.commit("setUser", res.user);
        this.context.commit("setPermissions", res.permissions);
        return this.user;
      });
    }
  }

  @Action public logout() {
    this.context.commit("setUser", {});
    this.context.commit("setPermissions", {});
    return UserApi.logout();
  }
}
